const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function normalizeAttitude(sample) {
  if (!sample || ![sample.x, sample.y, sample.z, sample.w].every(Number.isFinite)) return null;
  const length = Math.hypot(sample.x, sample.y, sample.z, sample.w);
  if (length < 0.001) return null;
  return Object.fromEntries(["x", "y", "z", "w"].map((key) => [key, sample[key] / length]));
}

// Compare quaternions in the phone's initial coordinate frame. Unlike raw
// pitch/roll subtraction this remains stable when the phone is held upright.
export function relativeCardTilt(origin, current, screenAngle = 0) {
  const { x: ax, y: ay, z: az, w: aw } = origin;
  const { x: bx, y: by, z: bz, w: bw } = current;
  let x = aw * bx - ax * bw - ay * bz + az * by;
  let y = aw * by + ax * bz - ay * bw - az * bx;
  let z = aw * bz - ax * by + ay * bx - az * bw;
  let w = aw * bw + ax * bx + ay * by + az * bz;
  if (w < 0) [x, y, z, w] = [-x, -y, -z, -w];
  const magnitude = Math.hypot(x, y, z);
  const factor = magnitude > 0.00001 ? 2 * Math.atan2(magnitude, w) / magnitude : 2;
  const angle = screenAngle * Math.PI / 180;
  const horizontal = (y * Math.cos(angle) - x * Math.sin(angle)) * factor;
  const vertical = (x * Math.cos(angle) + y * Math.sin(angle)) * factor;
  const soften = (v) => Math.sign(v) * clamp((Math.abs(v) - 0.012) / 0.42, 0, 1);
  return { x: soften(horizontal), y: soften(vertical) };
}
